
      export interface IntrospectionResultData {
        __schema: {
          types: {
            kind: string;
            name: string;
            possibleTypes: {
              name: string;
            }[];
          }[];
        };
      }
      const result: IntrospectionResultData = {
  "__schema": {
    "types": [
      {
        "kind": "INTERFACE",
        "name": "Node",
        "possibleTypes": [
          {
            "name": "Query"
          },
          {
            "name": "Bdi2"
          },
          {
            "name": "Case"
          },
          {
            "name": "Involvement"
          },
          {
            "name": "User"
          },
          {
            "name": "InterviewOffer"
          },
          {
            "name": "InterviewBooking"
          },
          {
            "name": "InterviewReport"
          },
          {
            "name": "CaseMessage"
          },
          {
            "name": "DueTask"
          },
          {
            "name": "MyTaskLog"
          },
          {
            "name": "Phq9"
          },
          {
            "name": "LoginToken"
          },
          {
            "name": "Letter"
          },
          {
            "name": "LetterTemplate"
          },
          {
            "name": "Sewip"
          },
          {
            "name": "Lsa"
          },
          {
            "name": "Pathev"
          },
          {
            "name": "Inep"
          },
          {
            "name": "Demographic"
          },
          {
            "name": "Eurohi"
          },
          {
            "name": "Gad7"
          },
          {
            "name": "Mspss"
          },
          {
            "name": "Pcl5"
          },
          {
            "name": "Pg13"
          },
          {
            "name": "Phq15"
          },
          {
            "name": "Pmb"
          },
          {
            "name": "Wai"
          },
          {
            "name": "Trgi"
          },
          {
            "name": "Traumaliste"
          },
          {
            "name": "Disclosure"
          },
          {
            "name": "Evaluation"
          },
          {
            "name": "Taq"
          },
          {
            "name": "CbtActivity"
          },
          {
            "name": "CbtReframing"
          },
          {
            "name": "CbtThought"
          },
          {
            "name": "Lec5"
          },
          {
            "name": "IptConflict"
          },
          {
            "name": "IptRelationship"
          },
          {
            "name": "IptSituation"
          },
          {
            "name": "Comment"
          },
          {
            "name": "CaseSuicideCall"
          },
          {
            "name": "Scaling"
          },
          {
            "name": "RandomizationTicket"
          },
          {
            "name": "SuicideNote"
          },
          {
            "name": "FeedbackInterviewReport"
          },
          {
            "name": "HashedEmail"
          }
        ]
      }
    ]
  }
};
      export default result;
    